import React from 'react';
import './brand.css';
import kia from '../../assets/kia.png';
import hyundai from '../../assets/hyundai.png';
import nissan from '../../assets/nissan.png';

const Brand = () => {
    return (
        <div className='gpt3__brand-wrapper'>
            <div className='gpt3__brand-heading'>
                <p>Supported Manufacturers</p>
                <div className='gpt3__brand-subtext'>
                    <span>Nissan (Hitachi GEN1/GEN2, Denso SH705X)</span>
                    <span className='divider'>|</span>
                    <span>Kia/Hyundai (Kefico CPEG Series, SIM2K Series)</span>
                </div>
            </div>
            <div className='gpt3__brand'>
                <div className="gpt3__brand-logo">
                    <img src={nissan} alt="nissan" />
                    <p>NISSAN</p>
                </div>

                <div className="gpt3__brand-logo">
                    <img src={hyundai} alt="hyundai" />
                    <p>HYUNDAI</p>
                </div>

                <div className="gpt3__brand-logo">
                    <img src={kia} alt="kia" />
                    <p>KIA</p>
                </div>
            </div>
        </div>
    )
}

export default Brand;
